import { useEffect, useState } from 'react'
import { useFloating, offset, flip, shift } from '@floating-ui/react'
import { createPortal } from 'react-dom'

export default function Dropdown({ trigger, triggerClassName, children }) {
  const [isOpen, setIsOpen] = useState(false)
  const { refs, floatingStyles } = useFloating({
    placement: 'bottom-start',
    middleware: [offset(8), flip(), shift()]
  })

  const handleDocumentClick = (e) => {
    if (
      isOpen &&
      refs.floating.current &&
      !refs.floating.current.contains(e.target) &&
      refs.reference.current &&
      !refs.reference.current.contains(e.target)
    ) {
      setIsOpen(false)
    }
  }

  const handleKeyDown = (e) => {
    if (e.key == 'Escape' && isOpen) {
      setIsOpen(false)
    }
  }

  useEffect(() => {
    document.addEventListener('click', handleDocumentClick)
    document.addEventListener('keydown', handleKeyDown)
    return () => {
      document.removeEventListener('click', handleDocumentClick)
      document.removeEventListener('keydown', handleKeyDown)
    }
  })

  return (
    <>
      <div className={classNames('dropdown-wrapper', triggerClassName)} ref={refs.setReference} onClick={() => setIsOpen(!isOpen)}>
        {trigger}
      </div>

      {isOpen &&
        createPortal(
          <div ref={refs.setFloating} style={floatingStyles} className="dropdown-container dropdown-menu-self scrollable">
            {children}
          </div>,
          document.querySelector('.master-container')
        )}
    </>
  )
}
